import React from 'react';

/**
 * Componente para navegação entre recursos na timeline (estilo Instagram/X)
 * 
 * Permite navegação horizontal entre profissionais/recursos
 * Design moderno otimizado para dispositivos móveis
 * 
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.hasMoreLeft - Se há mais recursos à esquerda
 * @param {boolean} props.hasMoreRight - Se há mais recursos à direita
 * @param {Function} props.onPrevious - Função para navegar para recursos anteriores
 * @param {Function} props.onNext - Função para navegar para recursos seguintes
 * @returns {JSX.Element} - Componente React
 */
const ResourceNavigation = ({ 
  hasMoreLeft, 
  hasMoreRight, 
  onPrevious, 
  onNext 
}) => {
  return (
    <div className="resource-navigation absolute inset-y-0 inset-x-0 flex justify-between items-center z-10 pointer-events-none">
      {hasMoreLeft && (
        <button 
          className="bg-white/75 text-blue-500 h-9 w-7 flex items-center justify-center rounded-r-lg shadow-sm backdrop-blur-sm pointer-events-auto transform transition hover:bg-white/90 hover:text-blue-600 active:scale-95"
          onClick={onPrevious}
          aria-label="Ver profissionais anteriores"
          style={{ 
            marginLeft: '1px',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}
      {hasMoreRight && (
        <button 
          className="bg-white/75 text-blue-500 h-9 w-7 flex items-center justify-center rounded-l-lg shadow-sm backdrop-blur-sm pointer-events-auto transform transition hover:bg-white/90 hover:text-blue-600 active:scale-95"
          onClick={onNext}
          aria-label="Ver próximos profissionais"
          style={{ 
            marginRight: '1px',
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ResourceNavigation; 